<template>
  <donut-chart-card
    :size="size"
    :title="title"
    :value="data"
    :init-total="total"
    :unit="unit"
    :isMoveWrite="isMoveWrite"
    :is-move-detail="isMoveDetail"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
/* eslint-disable brace-style */
import DonutChartCard from '@/components/DonutChartCard'

export default {
  name: 'DonutChart104Template',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    size: String,
    reloadCount: Number,
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
    title: {
      type: String,
      default: () => "안전·보건 교육 현황"
    },
    unit: {
      type: String,
      default: () => "건"
    },
    boardIds: {
      type: Array,
      default: () => [938, 940]
    },
    fieldCode: {
      type: String,
      default: undefined,
    },
    graphId: {
      type: Number,
      default: () => 0
    },
    dateField: {
      type: String,
      default: () => '$.body.education_date'
    },
    depth: {
      type: Number,
      default: 1
    },
    isMoveDetail: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  watch: {
    dataType (/*value*/) {
      this.loadGraph()
    },
  },
  data () {
    return {
      data: [{label: '데이터 없음', value: 0}],
      total: '0',
      cache: {},
    }
  },
  async mounted () {
    await this.loadDetailData();
    await this.loadGraph()
  },
  methods: {
    async loadDetailData(currentYear) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }
      const depth = this.depth || 1;

      const cacheKey = `detail_${currentYear}_${depth}`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return JSON.parse(JSON.stringify(this.cache[cacheKey]));
      }
      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      else {
        const params = {
          boardIds: this.boardIds,
          projectId: this.projectId,
          fieldCode: this.fieldCode,
          depth,
        };

        const data = await this.$store.dispatch("summary/LOAD_DONUT_104_DETAIL", params);
        this.cache[cacheKey] = data;
        return data;
      }
    },
    async loadGraph () {
      const data = await this.loadDetailData()

      let graph2Data = [];
      if (!this.projectId) {
        graph2Data = data.project;
      } else {
        graph2Data = data.educationType;
      }

      const currentYear = new Date().getFullYear();

      // currentData 아이템들을 누적해서 합산한다
      const sumData = [];
      let rowSum = 0;
      const memberInfo = this.$store.state.member.memberInfo;

      // 기존 다른 타입들의 처리
      const yearData = graph2Data[currentYear];
      let monthlyDataList = [];
      // 13개일 경우, 0번째가 총 합이 들어있다.
      if (yearData.length === 13) {
        monthlyDataList = [yearData[0]];
      } else {
        monthlyDataList = yearData;
      }

      for (const monthlyData of monthlyDataList) {
        for (const projectData of monthlyData) {
          let label = projectData.label;
          // 2024.05.02
          // https://app.clickup.com/t/86ep8969h
          // 경남도청의 경우, 조회한 사용자의 소속을 표시한다.
          if (label === '경남도청' && parseInt(projectData.company_id) === parseInt(memberInfo.company_id) && memberInfo.section) {
            label = memberInfo.section;
          }

          const count = projectData.educated_count;
          rowSum += count;

          const foundRow = sumData.find((row) => row.label === label);
          if (foundRow) {
            foundRow.count += count;
          } else {
            sumData.push({label, count});
          }
        }
      }

      // sumData를 count로 정렬한다
      sumData.sort((a, b) => b.count - a.count);


      const list = [];
      let no = 1;

      for (const row of sumData) {
        list.push({
          label: row.label,
          value: row.count,
        });
        no += 1;

        if (no > 5) break;
      }

      this.data = list;

      if (this.getLevel === 4 && this.dataType === 'detail') {
        this.total = rowSum;
      } else {
        this.total = data.monthlyEducated[currentYear][0];
      }
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
